<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5" md="4" lg="3">
        <v-card>
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            WindReports
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <h2 class="title mb-4">Restablecer contraseña</h2>
                </v-col>
                
                <v-col cols="12">
                  <p>Introduce tu nombre de usuario. <br>Te enviaremos un correo electrónico con información para restablecer tu contraseña.</p>
                </v-col>
                
                <v-col cols="12">
                  <v-text-field
                    class="pt-2"
                    label="Nombre de usuario"
                    name="username"
                    prepend-icon
                    type="text"
                    v-model="username"
                    :rules="usernameRules"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="pt-0 pb-4">
            <v-spacer></v-spacer>
            <v-btn text :to="{ name: 'login'}">Cancelar</v-btn>
            <v-btn
              color="primary"
              depressed
              :loading="loading"
              :disabled="loading"
              @click="handleSubmit($event)"
            >Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthClient } from "@/api/AuthClient";

export default {
  props: {},
  data: () => ({
    username: null,
    loading: false,
    usernameRules: [v => !!v || "Requerido"]
  }),
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        AuthClient.recovery(this.username)
          .then(_ => {
            this.loading = false;
            this.$toast("Se ha enviado el token para resetear la contraseña al correo, revisa tu bandeja de entrada.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.$router.push({
              name: "login"
            });
          })
          .catch(_ => {
            this.loading = false;
            this.$toast("No se ha podido enviar la recuperación al usuario.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
          });
      }
    }
  }
};
</script>
